import axios from "axios";

export default class OpenToMove {
  constructor() {
    this.API_LINK = process.env.VUE_APP_API_LINK;

  }

  /*  ROUTES,STOPS,PLATFORMS  */
  async getListsOpenToMove(queries) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/open-to-move/requests`,
        data: queries
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getListUO(queries) {
    try {
      const response = await axios({
        method: "POST",
        url: `${this.API_LINK}/open-to-move/ous`,
        data: queries
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }


  async getListSUBUO(queries) {
    try {
      const response = await axios({
        method: "POST",
        url: `${this.API_LINK}/open-to-move/ou-subs`,
        data: queries
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }


  async ChangeState(data,id) {
    try {
      const response = await axios({
        method: "put",
        url: `${this.API_LINK}/open-to-move/requests/${id}`,
        data: data
      });
      return response;
    } catch (error) {
      throw error.response;
    }
  }




  async postNotif(notif) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/plant/notification/`,
        data: notif
      });
      return response;
    } catch (error) {
      throw error.response;
    }
  }


  async createUO(json) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/open-to-move/ous/`,
        data: json
      });
      return response;
    } catch (error) {
      throw error.response;
    }
  }

  async createSubUO(data) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/open-to-move/ou-subs`,
        data
      });
      return response;
    } catch (error) {
      throw error.response;
    }
  }

  async updateSubUO(data, id) {
    try {
      const response = await axios({
        method: "patch",
        url: `${this.API_LINK}/open-to-move/ou-subs/${id}`,
        data
      });
      return response;
    } catch (error) {
      throw error.response;
    }
  }


  async querySubs(json) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/open-to-move/ou-subs`,
        data: json
      });
      return response;
    } catch (error) {
      throw error.response;
    }
  }






}
